/*
 * Authentication Middleware Utilities
 * Handles token validation and customer authentication
 */

import { callAction } from './api';

/**
 * Validate customer token
 * @param {string} token - Customer access token
 * @returns {Promise<{valid: boolean, customer?: object}>}
 */
export async function validateToken(token) {
  try {
    // Call validation action to check if token is valid
    const result = await callAction('commerce/validate-token', { token });
    return {
      valid: result.success === true,
      customer: result.customer || null
    };
  } catch (error) {
    return {
      valid: false,
      customer: null
    };
  }
}

export async function getCustomerToken() {
  try {
    const result = await callAction('commerce/get-customer-token');
  } catch(error) {
    return null;
  }
}

/**
 * Get customer data from token
 * @param {string} token - Customer access token
 * @returns {Promise<object|null>}
 */
export async function getCustomerFromToken(token) {
  try {
    const result = await callAction('commerce/customer-info', { token });
    if (result.success && result.customer) {
      return {
        ...result.customer,
        accessToken: token
      };
    }
    return null;
  } catch (error) {
    return null;
  }
}

/**
 * Check if customer is authenticated
 * @param {object} customerData
 * @returns {boolean}
 */
export function isCustomerAuthenticated(customerData) {
  return !!(
    customerData &&
    customerData.accessToken &&
    (customerData.id || customerData.email)
  );
}

/**
 * Store authentication data in session storage
 * @param {object} customerData
 */
export function storeAuthData(customerData) {
  try {
    localStorage.setItem('customer_auth', JSON.stringify(customerData));
  } catch (error) {
    throw error;
  }
}


/**
 * Retrieve authentication data from session storage
 * @returns {object|null}
 */
export function retrieveAuthData() {
  try {
    const data = localStorage.getItem('customer_auth');
    return data ? JSON.parse(data) : null;
  } catch (error) {
    return null;
  }
}


/**
 * Clear authentication data from session storage
 */
export function clearAuthData() {
  try {
    localStorage.removeItem('customer_auth');
  } catch (error) {
    return false;
  }
}
